import { create } from "zustand";
import { persist } from "zustand/middleware";

interface GuestStore {
  guestOrderId: string | null;
  comparisonList: string[];
  comparisonDisplayData: any[];
  setGuestOrderId: (id: string) => void;
  favoriteList: any[];
  favoriteDisplayData: any[];
  viewedList: any[];
  

  clearGuestOrderId: () => void;
  addToComparison: (id: string) => void;
  removeFromComparison: (id: string) => void;
  clearComparison: () => void;
  setComparisonDisplayData: (data: any[]) => void;
  clearComparisonDisplayData: () => void;
  addToFavorite: (id: string) => void;
  removeFromFavorite: (id: string) => void;
  clearFavorite: () => void;
  setFavoriteDisplayData: (data: any[]) => void;
  clearFavoriteDisplayData: () => void;
  addToViewedList: (id: string) => void;
}

export const useGuestStore = create<GuestStore>()(
  persist(
    (set, get) => ({
      guestOrderId: null,
      comparisonList: [],
      comparisonDisplayData: [],
      favoriteDisplayData: [],
      setGuestOrderId: (id) => set({ guestOrderId: id }),
      clearGuestOrderId: () => set({ guestOrderId: null }),
      favoriteList: [],
      viewedList: [],

      addToComparison: (id) => {
        if (!id) return; // skip if id is null or undefined
        const list = get().comparisonList.filter(Boolean); // clean existing list
        if (!list.includes(id)) {
          set({ comparisonList: [...list, id] });
        }
      },
      removeFromComparison: (id) => {
        const list = get().comparisonList.filter(Boolean); // remove nulls
        set({
          comparisonList: list.filter((item) => item !== id),
        });
      },
      clearComparison: () => set({ comparisonList: [] }),
      setComparisonDisplayData: (data) => set({ comparisonDisplayData: data }),
      clearComparisonDisplayData: () => set({ comparisonDisplayData: [] }),

      addToFavorite: (id) => {
        if (!id) return; // skip if id is null or undefined
        const list = get().favoriteList.filter(Boolean); // clean existing list
        if (!list.includes(id)) {
          set({ favoriteList: [...list, id] });
        }
      },
      removeFromFavorite: (id) => {
        const list = get().favoriteList.filter(Boolean); // remove nulls
        set({
          favoriteList: list.filter((item) => item !== id),
        });
      },
      clearFavorite: () => set({ favoriteList: [] }),
      setFavoriteDisplayData: (data) => set({ favoriteDisplayData: data }),
      clearFavoriteDisplayData: () => set({ favoriteDisplayData: [] }),
      addToViewedList: (id) => {
        if (!id) return; // skip if id is null or undefined
        const list = get().viewedList.filter(Boolean); // clean existing list
        if (!list.includes(id)) {
          set({ viewedList: [...list, id] });
        }
      },
    }),
    {
      name: "guest-storage", // key in localStorage
    }
  )
);

